import React from 'react';
import HIHRichText from './RichText';
import Image from 'next/image';
import styles from './Quote.module.scss';

const Quote = ({
  text,
  title,
  disclaimer,
  className,
}: {
  text: any;
  title?: string;
  disclaimer?: string;
  className?: string;
}) => {
  if (!text) {
    return null;
  }

  return (
    <div className={[styles.quote, className].filter(Boolean).join(' ')}>
      {title && <h5 className={styles.title}>{title}</h5>}

      <div className={styles.content}>
        <HIHRichText value={text} />
        {disclaimer && (
          <div className={styles.disclaimer}>
            <Image src="/icons/icon-info.svg" width={24} height={24} alt="Hinweis" />
            <p>{disclaimer}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quote;
